import React from 'react';
import ModernHeader from '../components/ModernHeader';
import Footer from '../components/Footer';
import { useSettings } from '../context/SettingsContext';

const PrivacyPolicy = () => {
  const { settings } = useSettings();
  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)' }}>
      <ModernHeader tenant={{ name: 'Tiket Jini' }} />
      <div style={{ maxWidth: '800px', margin: '0 auto', background: 'white', borderRadius: '20px', padding: '40px', boxShadow: '0 10px 40px rgba(0,0,0,0.1)', marginTop: '40px', marginBottom: '40px' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <img src="/Logo1.png" alt="Tiket Jini" style={{ width: '60px', height: '60px', borderRadius: '12px', marginBottom: '20px' }} />
          <h1 style={{ fontSize: '2.5rem', fontWeight: '800', color: '#2d3748', marginBottom: '10px' }}>Privacy Policy</h1>
          <p style={{ color: '#64748b', fontSize: '1.1rem' }}>Last updated: December 2024</p>
        </div>

        <div style={{ lineHeight: '1.8', color: '#4a5568' }}>
          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>1. Information We Collect</h2>
            <p>We collect information you provide directly to us, such as:</p>
            <ul style={{ paddingLeft: '20px' }}>
              <li>Name, email address, and phone number</li>
              <li>Payment information (processed securely)</li>
              <li>Booking preferences and history</li>
              <li>Communication with our support team</li>
            </ul>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>2. How We Use Your Information</h2>
            <ul style={{ paddingLeft: '20px' }}>
              <li>Process your bookings and payments</li>
              <li>Send booking confirmations and updates</li>
              <li>Provide customer support</li>
              <li>Improve our services and user experience</li>
              <li>Send promotional offers (with your consent)</li>
            </ul>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>3. Information Sharing</h2>
            <p>We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:</p>
            <ul style={{ paddingLeft: '20px' }}>
              <li>With venue partners to process your bookings</li>
              <li>With payment processors for transaction processing</li>
              <li>When required by law or legal process</li>
              <li>To protect our rights and safety</li>
            </ul>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>4. Data Security</h2>
            <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.</p>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>5. Your Rights</h2>
            <ul style={{ paddingLeft: '20px' }}>
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your data</li>
              <li>Opt-out of marketing communications</li>
            </ul>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>6. Cookies</h2>
            <p>We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. You can control cookie settings through your browser.</p>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>7. Contact Us</h2>
            <p>If you have questions about this Privacy Policy, please contact us at:</p>
            <ul style={{ paddingLeft: '20px' }}>
              <li>Email: privacy@tiketjini.com</li>
              <li>Phone: {settings.supportPhone}</li>
            </ul>
          </section>
        </div>

        <div style={{ textAlign: 'center', marginTop: '40px' }}>
          <button
            onClick={() => window.location.href = '/'}
            style={{
              background: 'linear-gradient(45deg, #3b82f6, #8b5cf6)',
              color: 'white',
              border: 'none',
              padding: '12px 30px',
              borderRadius: '25px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            ← Back to Home
          </button>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;